<template>
    <div class="page-section">
        <img v-if="headerImage" :src="headerImage" class="banner-image w-100" />

        <div class="container">
            <div class="row">
                <div class="col-lg-4">
                    <h1>{{ pageName }}</h1>
                    <div class="button-container">
                        <slot name="buttons"></slot>
                    </div>
                </div>
                <div class="col-lg">
                    <slot></slot>
                    <p v-if="footerImage != null" class="text-end">
                        <img :src="footerImage" style="width: 250px;" />
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        pageName: { 
            type: String,
            required: true
        },
        headerImage: {
            type: String,
            required: false
        },
        footerImage: { 
            type: String,
            required: false
        },    
    },
}
</script>

<style>
    .button-container {
        margin-bottom: 30px;
    }
</style>
